'use-strict';

import PhotoSwipeLightbox from './photoswipe-lightbox.esm.min.js';
import Photoswipe from './photoswipe.esm.min.js';
// js gallery
class ZoomAction extends HTMLElement {
  constructor() {
    super();
    this.type = this.dataset.type || 'no_zoom';
    this.zoomOption = this.dataset.zoomOption || 'external';
    this.lightbox = null;
    this.drift = null;
    this.init();
  }
  init() {
    if (this.type === 'no_zoom') return;
    window.addEventListener('resize', this.responsive.bind(this));
    window.addEventListener('load', this.responsive.bind(this));
  }
   initLightBox() {
    if (this.lightbox !== null) return;
  
   this.querySelectorAll('a.media-gallery__image:not([data-media-type="video"])').forEach((a) => {
  a.addEventListener('click', (e) => {
    e.preventDefault();

    // Build a clean list of real image anchors (ignore videos + swiper clones)
    const imageLinks = Array.from(
      this.querySelectorAll('a.media-gallery__image:not([data-media-type="video"]):not(.swiper-slide-duplicate)')
    );

    // Find the actual clicked image index among image-only items
    const correctIndex = imageLinks.indexOf(a);
    console.log('Correct index to open:', correctIndex);

    // Initialize lightbox (only once)
    if (!this.lightbox) {
      this.lightbox = new PhotoSwipeLightbox({
        gallery: this,
        children: 'a.media-gallery__image:not([data-media-type="video"]):not(.swiper-slide-duplicate)',
        pswpModule: () => Photoswipe,
        counter: false,
        zoom: false,
        preloader: false,
        arrowPrev: false,
        arrowNext: false,
        close: false,
        loop: false,
        bgOpacity: 1,
      });

      this.lightbox.on('uiRegister', () => {
        const { pswp } = this.lightbox;
        pswp?.ui.registerElement({
          name: 'bls--close',
          isButton: true,
          tagName: 'button',
          html: '<svg width="13" height="13" viewBox="0 0 13 13" fill="none" class="transition"><use href="#icon-close"></use></svg>',
          onClick: () => pswp.close(),
        });

        pswp?.ui.registerElement({
          name: 'bottomBar',
          className: 'pswp__bottom-bar',
          appendTo: 'wrapper',
          onInit: (el, pswp) => {
            const next = document.createElement('button');
            next.type = 'button';
            next.className = 'pswp__button pswp__button-next';
            next.innerHTML = `<svg width="6" height="11" fill="none"><use href="#icon-next"></use></svg>`;
            next.onclick = () => pswp.next();
            el.appendChild(next);

            const counter = document.createElement('span');
            counter.className = 'pswp__counter';
            pswp.on('change', () => {
              counter.innerText = `${pswp.currIndex + 1}${pswp.options.indexIndicatorSep}${pswp.getNumItems()}`;
            });
            el.appendChild(counter);

            const prev = document.createElement('button');
            prev.type = 'button';
            prev.className = 'pswp__button pswp__button-prev';
            prev.innerHTML = `<svg width="6" height="11" fill="none"><use href="#icon-back"></use></svg>`;
            prev.onclick = () => pswp.prev();
            el.appendChild(prev);
          },
        });
      });

      this.lightbox.init();
    }

    // ✅ Open exactly the clicked image
    this.lightbox.loadAndOpen(correctIndex);
  });
});

  }
   initDrift() {
    if (this.drift !== null) return;
    var allTriggers = this.querySelectorAll('.drift-trigger');
    var paneContainer = this.closest('.sec__featured-product').querySelector(
      '.zoom-external-area'
    );
    if (allTriggers.length != 0) {
      allTriggers.forEach( (trigger) => {
        const inlineContainer = trigger.closest('[data-pane-container]');
        const zoomOption = this.zoomOption;
        if (zoomOption === 'inner-2') {
          this.drift = new Drift(trigger, {
            inlinePane: zoomOption === 'inner-2',
            zoomFactor: 3,
            containInline: paneContainer,
            paneContainer: inlineContainer,
            hoverBoundingBox: zoomOption === 'external',
            onShow: function () {
              inlineContainer.classList.add('relative');
            },
            onHide: function () {
              inlineContainer.classList.remove('relative');
            },
          });
        } else {
          this.drift = new Drift(trigger, {
            inlinePane: zoomOption,
            zoomFactor: 5,
            containInline: !!paneContainer,
            paneContainer:
              zoomOption === 'external' ? paneContainer : inlineContainer,
            hoverBoundingBox: zoomOption === 'external',
            onShow: function () {
              inlineContainer.classList.add('relative');
            },
            onHide: function () {
              inlineContainer.classList.remove('relative');
            },
          });
        }
      });
    }
  }
  responsive() {
    if (window.innerWidth >= 768) {
      if (this.type === 'open_lightbox') {
        this.initLightBox();
      } else {
        if (this.lightbox !== null) {
          this.lightbox.destroy();
          this.lightbox = null;
        }
        this.initDrift();
      }
    } else {
      if (this.type !== 'open_lightbox') {
        if (this.drift !== null) {
          this.drift.destroy();
          this.drift == null;
        }
        this.initLightBox();
      } else {
        this.initLightBox();
      }
    }
    this.updateSwiper();
  }

  updateSwiper() {
    if (typeof Swiper !== 'undefined') {
      if (this.querySelector('.thumbnail-slide')) {
        this.querySelector('.thumbnail-slide').swiper.update();
      }
    }
  }

  disconnectedCallback() {
    window.removeEventListener('resize', this.responsive.bind(this));
    window.removeEventListener('load', this.responsive.bind(this));
  }
}
customElements.define('zoom-action', ZoomAction);
